import ComponentHelper from '../../../../supers/ComponentHelper';
import React from 'react';
import InputField from '../../../../components/input-field/InputField';
import ValidationService from '../../../../services/ValidationService';
import { view } from 'react-easy-state';
import _ from 'lodash';
import Dropdown from '../../../../components/dropdown/Dropdown';
import './entity-field-picker.css';
const VS = new ValidationService();

class EntityFieldPicker extends ComponentHelper {
	constructor(props) {
		super(props);
		this.autoBindAll(this, null, true);
		this.setInitialData(props);
	}

	setInitialData(props) {
		this.data = props.formData;
		this.data.entities = props.entities;
		this.data.afterAdd = props.afterAdd;
	}

	componentWillReceiveProps(nextProps) {
		if (!this.props.isOpen && nextProps.isOpen) {
			this.observe(() => {
				this.setInitialData(nextProps);
			});
		}
	}

	onNameChange(evt) {
		if (VS.validateField(evt.target.value)) {
			this.data[evt.target.name] = evt.target.value;
		}
	}

	getTypes(array) {
		let items = [];
		let types = ['string', 'number', 'integer', 'boolean', 'entity', 'any'];
		if (array) {
			types.push('array');
		}
		_.forEach(types, type => {
			items.push({
				value: type,
				label: _.upperFirst(type)
			});
		});
		return items;
	}

	onTypeChange(newVal) {
		if (newVal) {
			this.data.fieldType = newVal.value;
		}
	}

	onArrTypeChange(newVal) {
		if (newVal) {
			this.data.arrFieldType = newVal.value;
		}
	}

	onRelationChange(newVal) {
		this.data.relation = newVal.value;
	}

	getEntities() {
		let ents = this.data.entities;
		let items = [];
		_.forEach(ents, entity => {
			items.push({
				value: `${entity.name}`,
				label: entity.displayName
			});
		});
		return items;
	}

	validField() {
		if (this.data.fieldType === 'entity' && this.data.relation.length <= 0) {
			return false;
		}
		if (this.data.fieldType === 'array' && this.data.arrFieldType.length <= 0) {
			return false;
		}
		if (this.data.fieldType === 'array' && this.data.arrFieldType === 'entity' && this.data.relation.length <= 0) {
			return false;
		}
		return this.data.fieldType.length > 0 && this.data.fieldName.length > 0;
	}

	addField() {
		let { fieldName, fieldType, arrFieldType, relation, schema: { properties } } = this.data;
		if (fieldType === 'array') {
			if (arrFieldType !== 'entity') {
				properties[fieldName] = { type: fieldType, items: { type: arrFieldType } };
			} else {
				properties[fieldName] = { type: fieldType, items: { type: relation } };
			}
		} else if (fieldType === 'entity' && relation.length > 0) {
			properties[fieldName] = { type: relation };
		} else {
			properties[fieldName] = { type: fieldType };
		}
		this.data.fieldName = '';
		this.data.relation = '';
		this.data.arrFieldType = 'string';
		if (this.data.afterAdd) {
			this.data.afterAdd();
		}
	}

	keyPress(evt) {
		if (evt.key === 'Enter' && this.validField()) {
			evt.preventDefault();
			this.addField();
		}
	}

	buildFieldContent() {
		let { fieldName, fieldType, arrFieldType, relation } = this.data;
		return (
			<div className="entity-field-picker hbox">
				<InputField
					label="Field Name"
					name="fieldName"
					type="text"
					value={fieldName}
					handleChange={this.onNameChange}
					onKeyDown={this.keyPress}
					placeholder="Enter a unique name"
					className="m-r-10"
					required
					autoFocus
				/>
				<Dropdown
					className="m-r-10 type-picker"
					label="Field Type"
					value={fieldType}
					placeholder="Select type"
					handleChange={this.onTypeChange}
					name="typePicker"
					options={this.getTypes(true)}
				/>
				{fieldType === 'array' && (
					<Dropdown
						className="array-type-picker"
						label="Array Item Type"
						value={arrFieldType}
						placeholder="Select type"
						handleChange={this.onArrTypeChange}
						name="typePicker"
						options={this.getTypes()}
					/>
				)}
				{(fieldType === 'entity' || arrFieldType === 'entity') && (
					<Dropdown
						className="relation-picker"
						label="Entity"
						value={relation}
						placeholder="Select Entity"
						handleChange={this.onRelationChange}
						name="typePicker"
						options={this.getEntities()}
					/>
				)}
				<button className="btn primary square add-btn vbox hcenter vcenter" disabled={!this.validField()} title="Add Field" onClick={this.addField}>
					<i className="mdi mdi-plus" />
				</button>
			</div>
		);
	}

	render() {
		return this.buildFieldContent();
	}
}
export default view(EntityFieldPicker);



// WEBPACK FOOTER //
// ./src/views/entities-panel/entity-list/entity-field-picker/EntityFieldPicker.js